import { initializeApp, type FirebaseApp } from "firebase/app";
import {
  browserLocalPersistence,
  GithubAuthProvider,
  GoogleAuthProvider,
  getAuth,
  setPersistence,
  type Auth,
} from "firebase/auth";

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseConfigured = Object.values(config).every(
  (value) => typeof value === "string" && value.trim().length > 0,
);

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
export let firebaseAuthReady: Promise<void> = Promise.resolve();

if (firebaseConfigured) {
  app = initializeApp(config);
  auth = getAuth(app);
  firebaseAuthReady = setPersistence(auth, browserLocalPersistence);
}

export const firebaseAuth = auth;
export const googleProvider = new GoogleAuthProvider();
export const githubProvider = new GithubAuthProvider();

googleProvider.setCustomParameters({ prompt: "select_account" });
githubProvider.addScope("user:email");
